import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  FiUser, FiHelpCircle, FiInfo,
  FiChevronRight, FiLogOut,
} from 'react-icons/fi';
import './Settings.css';

const Settings = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [avatarError, setAvatarError] = useState(false);

  const displayName =
    user?.first_name && user?.last_name
      ? `${user.first_name} ${user.last_name}`
      : user?.name || 'User';

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const settingsOptions = [
    { title: 'Account', icon: <FiUser size={22} />, action: () => navigate('/profile') },
    { title: 'Help & Support', icon: <FiHelpCircle size={22} />, action: () => window.open('mailto:support@my-omni.link') },
    { title: 'About', icon: <FiInfo size={22} />, action: () => navigate('/about') },
  ];

  return (
    <div className="settings-container">
      <div className="settings-content">

        {/* Header */}
        <div className="settings-header">
          <h1 className="settings-title">Settings</h1>
          <p className="settings-subtitle">Manage your OMNI account</p>
        </div>

        {/* User Card */}
        <div className="settings-user-card">
          <div className="settings-user-avatar-wrap">
            {user?.avatar_url && !avatarError ? (
              <img
                src={user.avatar_url}
                alt="Avatar"
                className="settings-user-avatar-img"
                onError={() => setAvatarError(true)}
              />
            ) : (
              <div className="settings-user-avatar-placeholder">
                <FiUser size={36} color="#9AA3A8" />
              </div>
            )}
          </div>
          <p className="settings-user-name">{displayName}</p>
          <p className="settings-user-email">{user?.email || ''}</p>
        </div>

        {/* Options List */}
        <div className="settings-options-card">
          {settingsOptions.map((opt, i) => (
            <button
              key={i}
              className="settings-option-row"
              onClick={opt.action}
            >
              <div className="settings-option-left">
                <span className="settings-option-icon">{opt.icon}</span>
                <span className="settings-option-title">{opt.title}</span>
              </div>
              <FiChevronRight size={20} className="settings-option-chevron" />
            </button>
          ))}
        </div>

        {/* Logout */}
        {!showLogoutConfirm ? (
          <button className="settings-logout-btn" onClick={() => setShowLogoutConfirm(true)}>
            <FiLogOut size={22} />
            <span>Logout</span>
          </button>
        ) : (
          <div className="settings-logout-confirm">
            <p className="settings-logout-confirm-text">Are you sure you want to logout?</p>
            <div className="settings-logout-confirm-actions">
              <button className="settings-logout-cancel" onClick={() => setShowLogoutConfirm(false)}>
                Cancel
              </button>
              <button className="settings-logout-confirm-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Settings;
